module.exports = __webpack_public_path__ + "img/mv_list_right_pc.c1daa00c.svg";